/* eslint-disable css-modules/no-unused-class, no-extra-boolean-cast */
import { FC } from 'react';
import { Icon } from 'learning-panel-components';
import styles from './learningPathDetails.module.scss';

const LearningPathDetails: FC<LearningPathDetailsProps> = (props: LearningPathDetailsProps) => {
    const { score, progress, duration, certificate } = props;

    return (
        <div className={styles['learning-path-details']}>
            <div className={styles['learning-path-progress-duration']}>
                {duration && (
                    <div className={styles['learning-path-box']}>
                        <div className={styles['learning-path-details-duration']}>~{duration}</div>
                        <Icon name="clock" />
                    </div>
                )}
                {progress !== undefined && (
                    <div className={styles['learning-path-box']}>
                        <div className={styles['learning-path-details-progress']}>{progress}%</div>
                        <div
                            data-testid="pie-chart"
                            className={styles.pie}
                            style={
                                {
                                    '--completionRate': `${progress !== 100 ? progress * 3.6 : progress * 3.7}deg`
                                } as any
                            }
                        ></div>
                    </div>
                )}
            </div>

            <div className={styles['learning-path-certificate-score']}>
                <div className={styles['learning-path-box']}>
                    <div className={styles['learning-path-details-score']}>{score}</div>
                    <Icon name="devCoin" className={styles.coin} />
                </div>
                {certificate && (
                    <div className={styles['learning-path-box']}>
                        <img src={`${process.env.PUBLIC_URL}/images/smallCertificate.svg`} alt="" />
                    </div>
                )}
            </div>
        </div>
    );
};

export interface LearningPathDetailsProps {
    score: number;
    progress?: number;
    duration?: string;
    certificate: boolean;
}

export default LearningPathDetails;
